<template>
  <div>
    <div class="utilizationReport-title">
      <div>{{ $t("Bill.ResourceOptimization.utilizationRate") }}</div>
      <div></div>
    </div>
    <div class="utilizationReport-top">
      <utilization-report-search></utilization-report-search>
    </div>
    <table-utilization-report></table-utilization-report>
  </div>
</template>

<script>
import UtilizationReportSearch from "../utilization_report/UtilizationReportSearch";
import TableUtilizationReport from "../utilization_report/TableUtilizationReport";

export default {
  name: "CoverageReport",
  components: {
    UtilizationReportSearch,
    TableUtilizationReport,
  },
};
</script>

<style scoped>
.utilizationReport-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 8px 4px;
  font-weight: 600;
  overflow: hidden;
}
.utilizationReport-title > div:nth-child(1) {
  float: left;
}
.utilizationReport-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.utilizationReport-top {
  width: 100%;
  height: 53px;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/reserved_instance/utilization_report/UtilizationReport.vue